export interface ISuggestSectionProps {
  title: string;
}

export default function SuggestSection({ title }: ISuggestSectionProps) {
  return (
    <tr>
      <td colSpan={3} className="font-bolder py-2">
        {title}:
      </td>
    </tr>
  );
}
